/**
 * @generated SignedSource<<15062aa6703b4790b7ae77ba03cc0ac3>>
 * @relayHash 65a5eaa2c2c0770ae089a881f4759089
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 65a5eaa2c2c0770ae089a881f4759089

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      }
    ],
    "kind": "ScalarField",
    "name": "collegesWithMedicalCheck",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QCollegesWithMedicalCheckQueryQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QCollegesWithMedicalCheckQueryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "65a5eaa2c2c0770ae089a881f4759089",
    "metadata": {},
    "name": "QCollegesWithMedicalCheckQueryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "7752ae7cca205b6156719294315466e2";

export default node;
